import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/dietGuide/firstIntroPage.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  // 첫번째 페이지
  {
    path: '/firstIntro',
    name: 'firstIntro',
    component: () => import('@/components/dietGuide/firstIntroPage.vue')
  },
  // 빅데이터 목표 설정
  {
    path: '/BigDataGoalIntroPage',
    name: 'BigDataGoalIntroPage',
    component: () => import('../components/dietGuide/BigDataGoalIntroPage.vue')
  },
  {
    path: '/BigDataGoalStep1Page/:datetimes?',
    name: 'BigDataGoalStep1Page',
    component: () => import('../components/dietGuide/BigDataGoalStep1Page.vue')
  },
  {
    path: '/BigDataGoalStep2Page',
    name: 'BigDataGoalStep2Page',
    component: () => import('../components/dietGuide/BigDataGoalStep2Page.vue')
  },
  {
    path: '/BigDataGoalStep3Page',
    name: 'BigDataGoalStep3Page',
    component: () => import('../components/dietGuide/BigDataGoalStep3Page.vue')
  },
  {
    path: '/BigDataAnalysisLoadingPage',
    name: 'BigDataAnalysisLoadingPage',
    component: () => import('../components/dietGuide/BigDataAnalysisLoadingPage.vue')
  },
  {
    path: '/BigDataGoalStep4Page',
    name: 'BigDataGoalStep4Page',
    component: () => import('../components/dietGuide/BigDataGoalStep4Page.vue')
  },
  {
    path: '/BigDataResultPage',
    name: 'BigDataResultPage',
    component: () => import('../components/dietGuide/BigDataResultPage.vue')
  },
  {
    path: '/BigDataGoalHistoryPage',
    name: 'BigDataGoalHistoryPage',
    component: () => import('../components/dietGuide/BigDataGoalHistoryPage.vue')
  },
  // 식단 가이드
  {
    path: '/DietGuideIntroPage',
    name: 'DietGuideIntroPage',
    component: () => import('../components/dietGuide/DietGuideIntroPage.vue')
  },
  {
    path: '/DietGuideStep1Page',
    name: 'DietGuideStep1Page',
    component: () => import('../components/dietGuide/DietGuideStep1Page.vue')
  },
  {
    path: '/DietGuideStep2Page',
    name: 'DietGuideStep2Page',
    component: () => import('../components/dietGuide/DietGuideStep2Page.vue')
  },
  {
    path: '/DietGuideStep3Page',
    name: 'DietGuideStep3Page',
    component: () => import('../components/dietGuide/DietGuideStep3Page.vue')
  },
  {
    path: '/DietGuideResultPage',
    name: 'DietGuideResultPage',
    component: () => import('../components/dietGuide/DietGuideResultPage.vue')
  },
  {
    path: '/BasicWeightPlanPage',
    name: 'BasicWeightPlanPage',
    component: () => import('../components/dietGuide/BasicWeightPlanPage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
